var prefixSelector = function (selector) { return ".awsui-app-layout__" + selector; };
var Drawer = /** @class */ (function () {
    function Drawer(component, drawerName) {
        this.component = component;
        this.toggleSelector = prefixSelector("toggle--" + drawerName);
        var drawerSelector = prefixSelector(drawerName);
        this.drawer = component.node.querySelector(drawerSelector);
    }
    Drawer.prototype.isHidden = function () {
        throw new Error('Abstract method: Drawer.isHidden()');
    };
    Drawer.prototype.getToggleDesktopWidth = function (isMobile) {
        if (isMobile || this.isHidden()) {
            return 0;
        }
        // $toggleDesktopWidth value from base.scss
        return 40;
    };
    return Drawer;
}());
export default Drawer;
//# sourceMappingURL=drawer.js.map